import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/index/index'
import Main from '@/components/main/index'
// 1
import livelyResource from '@/components/main/livelyResource'
import affairAnalyze from '@/components/main/affairAnalyze'
import affairChange from '@/components/main/affairChange'
import affairPandect from '@/components/main/affairpandect'
// 2
import ditchsbox from '@/components/main/ditchsbox'
import ditchMediumBox from '@/components/main/ditchMediumBox'
import popularizeBox from '@/components/main/popularizeBox'
// 3
import courseChange from '@/components/main/courseChange'
// 4
import userControl from "@/components/main/userControl"

Vue.use(Router)


let vueRouter = new Router({
  mode:"history",
  routes: [
    {
      path: '/',
      name: 'Index',
      meta:{index:1},
      component: Home
    },
    {
      path: '/app/no',
      name: 'Main',
      meta:{index:2},
      component: Main
    },
    // 1-1
    {
      path:'/app/main/livelyResource',
      name:"Main",
      meta:{index:2},
      component:livelyResource,
    },
    // 1-2
    {
      path:'/app/main/affairAnalyze',
      name:"Main",
      meta:{index:2},
      component:affairAnalyze
    },
    // 1-3
    {
      path:'/app/main/affairChange',
      name:"Main",
      meta:{index:2},
      component:affairChange
    },
    // 1-4
    {
      path:'/app/main/affairPandect',
      name:"Main",
      meta:{index:2},
      component:affairPandect
    },
    // 2-1
    {
      path:'/app/main/ditchsbox',
      name:"Main",
      meta:{index:2},
      component:ditchsbox
    },
    // 2-2
    {
      path:'/app/main/ditchMediumBox',
      name:"Main",
      meta:{index:2},
      component:ditchMediumBox
    },
    // 2-3
    {
      path:'/app/main/popularizeBox',
      name:"Main",
      meta:{index:2},
      component:popularizeBox
    },
    // 3-1
    {
      path:'/app/main/courseChange',
      name:"Main",
      meta:{index:2},
      component:courseChange
    },
    // 4-1
    {
      path:'/app/main/userControl',
      name:"Main",
      meta:{index:2},
      component:userControl
    },
  ]
})

vueRouter.beforeEach((to,from,next)=>{
  if(to.name == null){
    if(!localStorage.getItem("token")){
      next('/')
    }else{
      next("/app/main/livelyResource")
      sessionStorage.setItem('nav',`{"a":0,"b":0}`)
    }
  }
  if(to.name == "Main" && from.name == "Index"){
    sessionStorage.setItem('nav',`{"a":0,"b":0}`)
  }
  if(to.name == "Main"){
    if(localStorage.getItem("xxx") == 1 && localStorage.getItem("token") && (Date.now()-localStorage.getItem("time") <7200000)){
      localStorage.setItem("setView",true)
      setTimeout(()=>{
        try {
          this.a.app.$store._actions.setView[0](true);
          this.a.app.$store._actions.setUser[0](JSON.parse(localStorage.getItem('get')));
        } catch (error) {
          
        }
      },1)
      next()
    }else{
      localStorage.removeItem("token")
      localStorage.removeItem("xxx")
      localStorage.removeItem("time")
      setTimeout(()=>{
        this.a.app.$store._actions.setView[0](false)
      },1)
      next('/')
    }
  }else if(to.path == "/" && from.name == "Main"){
    if(localStorage.getItem("xxx") == 1&& localStorage.getItem("token") && (Date.now()-localStorage.getItem("time") <7200000)){
      next(false)
    }else{
      localStorage.removeItem("token")
      localStorage.removeItem("xxx")
      localStorage.removeItem("time")
      next()
    }
  }else {
    next()
  }
})

export default vueRouter;



// WEBPACK FOOTER //
// ./src/router/index.js